<template>
  <Layout>
    <div class="flex justify-left" v-if="currentUserData.userType === 'admin'">
      <div class="py-2"></div>
          <button v-if="tab === 'searchMembers'"
            type="button"
            v-on:click=" setTab(''); "
            class="relative inline-flex items-center pl-4 px-5 py-0 pt-0 bg-white border border-transparent text-sm font-medium rounded-md text-blue-600 bg-white hover:text-yellow-600 focus:outline-none transition duration-150 ease-in-out"
            >
            <img class="h-6 w-6" src="../assets/turn-left.png" alt />
            <a  class="absolute inset-0 z-6 px-2 pl-2 bg-white text-center flex flex-col items-center justify-center opacity-0 hover:opacity-50 bg-opacity-80 duration-300">
            <h1 class=tracking-wider >Go Back</h1>
            </a>
       </button>
          <button v-if="tab === 'nonMembers'"
            type="button"
            v-on:click=" setTab(''); "
            class="relative inline-flex items-center pl-4 px-5 py-0 pt-0 bg-white border border-transparent text-sm font-medium rounded-md text-blue-600 bg-white hover:text-yellow-600 focus:outline-none transition duration-150 ease-in-out"
            >
            <img class="h-6 w-6" src="../assets/turn-left.png" alt />
            <a  class="absolute inset-0 z-6 px-2 pl-2 bg-white text-center flex flex-col items-center justify-center opacity-0 hover:opacity-50 bg-opacity-80 duration-300">
            <h1 class=tracking-wider >Go Back</h1>
            </a>
       </button>
            <button v-if="tab === 'searchVisitors'"
            type="button"
            v-on:click=" setTab(''); "
            class="relative inline-flex items-center pl-4 px-5 py-0 pt-0 bg-white border border-transparent text-sm font-medium rounded-md text-blue-600 bg-white hover:text-yellow-600 focus:outline-none transition duration-150 ease-in-out"
            >
            <img class="h-6 w-6" src="../assets/turn-left.png" alt />
            <a  class="absolute inset-0 z-6 px-2 pl-2 bg-white text-center flex flex-col items-center justify-center opacity-0 hover:opacity-50 bg-opacity-80 duration-300">
            <h1 class=tracking-wider >Go Back</h1>
            </a>
       </button>
         <button v-if="tab === 'searchSermons'"
            type="button"
            v-on:click=" setTab(''); "
            class="relative inline-flex items-center pl-4 px-5 py-0 pt-0 bg-white border border-transparent text-sm font-medium rounded-md text-blue-600 bg-white hover:text-yellow-600 focus:outline-none transition duration-150 ease-in-out"
            >
            <img class="h-6 w-6" src="../assets/turn-left.png" alt />
            <a  class="absolute inset-0 z-6 px-2 pl-2 bg-white text-center flex flex-col items-center justify-center opacity-0 hover:opacity-50 bg-opacity-80 duration-300">
            <h1 class=tracking-wider >Go Back</h1>
            </a>
       </button>
        <button v-if="tab === ''"
        type="button"
        v-on:click="setTab('searchSermons');"
        class="relative inline-flex items-center pl-4 px-5 py-4 bg-white border border-transparent text-sm font-medium rounded-md text-blue-600 bg-white hover:text-yellow-600 focus:outline-none transition duration-150 ease-in-out"
         >
        <img class="h-28 w-28 md:h-48 md:w-48 lg:h-48 lg:w-48 rounded-lg" src="../assets/searchSermons.png" alt />
        <a  class="absolute inset-0 z-6 px-4 pl-2 bg-white text-center flex flex-col items-center justify-center opacity-0 hover:opacity-50 bg-opacity-80 duration-300">
        <h1 class=tracking-wider >Sermons</h1>
        </a>
      </button>
        <button v-if="tab === ''"
        type="button"
        v-on:click= "setTab('searchMembers');"
        class="relative inline-flex items-center pl-4 px-5 py-4 bg-white border border-transparent text-sm font-medium rounded-md text-blue-600 bg-white hover:text-yellow-600 focus:outline-none transition duration-150 ease-in-out"
         >
        <img class="h-28 w-28 md:h-48 md:w-48 lg:h-48 lg:w-48 rounded-lg" src="../assets/members.jpg" alt />
        <a  class="absolute inset-0 z-6 px-4 pl-2 bg-white text-center flex flex-col items-center justify-center opacity-0 hover:opacity-50 bg-opacity-80 duration-300">
        <h1 class=tracking-wider >Members</h1>
        </a>
      </button>
           <button v-if="tab === ''"
        type="button"
        v-on:click= "setTab('searchVisitors');"
        class="relative inline-flex items-center pl-4 px-5 py-4 bg-white border border-transparent text-sm font-medium rounded-md text-blue-600 bg-white hover:text-yellow-600 focus:outline-none transition duration-150 ease-in-out"
         >
        <img class="h-28 w-28 md:h-48 md:w-48 lg:h-48 lg:w-48 rounded-lg" src="../assets/visitor.jpg" alt />
        <a  class="absolute inset-0 z-6 px-4 pl-2 bg-white text-center flex flex-col items-center justify-center opacity-0 hover:opacity-50 bg-opacity-80 duration-300">
        <h1 class=tracking-wider >Visitors</h1>
        </a>
      </button>
          <!-- <button v-if="tab === ''"
        type="button"
        v-on:click= "setTab('nonMembers');"
        class="relative inline-flex items-center pl-4 px-5 py-4 bg-white border border-transparent text-sm font-medium rounded-md text-blue-600 bg-white hover:text-yellow-600 focus:outline-none transition duration-150 ease-in-out"
         >
        <img class="h-28 w-28 md:h-48 md:w-48 lg:h-48 lg:w-48 rounded-lg" src="../assets/nonmember.jpg" alt />
        <a  class="absolute inset-0 z-6 px-4 pl-2 bg-white text-center flex flex-col items-center justify-center opacity-0 hover:opacity-50 bg-opacity-80 duration-300">
        <h1 class=tracking-wider >Non Members</h1>
        </a>
      </button>-->
            <button v-if="tab === ''"
        type="button"
        v-on:click= "setTab('');"
        class="relative inline-flex items-center pl-4 px-5 py-4 bg-white border border-transparent text-sm font-medium rounded-md text-blue-600 bg-white hover:text-yellow-600 focus:outline-none transition duration-150 ease-in-out"
         >
        <img class="h-28 w-28 md:h-48 md:w-48 lg:h-48 lg:w-48 rounded-lg" src="../assets/library2.jpg" alt />
        <a  class="absolute inset-0 z-6 px-4 pl-2 bg-white text-center flex flex-col items-center justify-center opacity-0 hover:opacity-50 bg-opacity-80 duration-300">
        <h1 class=tracking-wider >Library Coming Soon</h1>
        </a>
      </button>
    </div>
    <div v-if="tab === 'searchSermons'">
      <SearchIncidents />
    </div>
     <div v-if="tab === 'searchMembers'">
      <SearchMembers />
    </div>
      <div v-if="tab === 'nonMembers'">
      <SearchNonMembers />
    </div>
       <div v-if="tab === 'searchVisitors'">
      <SearchVisitors />
    </div>
    <!--<div v-if="currentUserData.userType === 'user'">
      <UserDashboard />
    </div>-->

    
    
   
  </Layout>
</template>

<script>
import { mapGetters } from "vuex";
import Layout from "./layouts/Main";
//import AdminDashboard from "../components/AdminDashboard";
import SearchIncidents from "../components/SearchIncidents.vue";
import SearchMembers from "../components/SearchMembers.vue";
import SearchNonMembers from "../components/SearchNonMembers.vue";
import SearchVisitors from "../components/SearchVisitors.vue";
//import UserDashboard from "../components/UserDashboard";
//import Onboarding from "../components/Onboarding";
//import TopLoaderPages from "../components/TopLoaderPages";


export default {
  name: "dashboard",
  components: {
    Layout,
    SearchIncidents,
    SearchMembers,
    SearchNonMembers,
    SearchVisitors,
   // UserDashboard,
    //Onboarding,
   

  },
  data() {
    return {
      user: {},
      employee: '',
      tab : "",
      pages : {},
    };
  },
  created() {
    //this.getUserData();
    this.type = this.currentUserData.userType;
    this.userStatus = this.currentUserData.status;
  
    this.getUserData();
    this.getPages();
  },
  mounted() {
    this.getUserData();
  },
  computed: {
    ...mapGetters(["isLoggedIn", "currentUserData"]),
  },
  methods: {
    getUserData() {
      const userData = this.$db
        .collection("users")
        .where("timestamp", "==", this.currentUserData.timestamp)
        .where("email", "==", this.currentUserData.email)
        //.where("contactNumber", "==", this.currentUserData.contactNumber);
        
      userData.get().then((querySnapshot) => {
        querySnapshot.forEach(doc => {
          const data = {
            'id': doc.id,
           ...doc.data()
          }
          this.user = data
          
        })
      }) 
    },
     setTab(tab) {
      this.tab = tab;
    },
    getPages() {
      //const employer = [];
      const employerData = this.$db
        .collection("websitestatus")
        .where("status", "==", "active");

      employerData.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            ...doc.data(),
          };
          this.pages = data;
        });
      });
    },
   
  }
  
};
</script>
